import { memo } from 'react';

import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import PeriodInDays, { PeriodVariants } from 'src/components/Price/PeriodInDays';
import PriceCartItemZP from 'src/components/Price/PriceCart/PriceCartItemZP';
import ActivationDate from 'src/components/Price/PriceCart/PriceCartProduct/ActivationDate';
import RegionAndProfArea from 'src/components/Price/PriceCart/PriceCartProduct/RegionAndProfArea';
import useContactsCount from 'src/components/Price/Tariff/useContactsCount';
import useOptionsCount from 'src/components/Price/Tariff/useOptionsCount';
import usePublicationsCount from 'src/components/Price/Tariff/usePublicationsCount';
import translation from 'src/components/translation';
import { ZpCartProductProps } from 'src/models/price/priceCart';
import { isUnlimitedResumeAccess } from 'src/utils/price/products';

const TrlKeys = {
    access: 'cvmarket.service.db',
};

const ZpBundles: TranslatedComponent<ZpCartProductProps> = ({ product, translations, trls }) => {
    const optionsCount = useOptionsCount(product);
    const publicationsCount = usePublicationsCount(product);
    const contactsCount = useContactsCount(product);
    const isUnlimited = isUnlimitedResumeAccess(product);

    return (
        <PriceCartItemZP
            dataQa={`cart-item__tariff-${product.tariff}`}
            product={product}
            title={translations.tariffTitle[product.tariff]}
        >
            <RegionAndProfArea product={product} />
            <VSpacing base={1} />
            {!!publicationsCount && <div>{publicationsCount}</div>}
            {!!optionsCount && <div>{optionsCount}</div>}
            {!!contactsCount && <div>{isUnlimited ? trls[TrlKeys.access] : contactsCount}</div>}
            <PeriodInDays period={product.period} variant={PeriodVariants.Default} />
            <VSpacing base={1} />
            <ActivationDate product={product} />
        </PriceCartItemZP>
    );
};

export default memo(translation(ZpBundles));
